// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"823":"70fcc1a7","1808":"df2f1b11","4888":"3bbf3c67","5937":"8da4c4d3","7909":"ce21834e","7913":"70fcc1a7","9168":"1102fd31"}[chunkId] + ".chunk.css";
};